import type { MessageInstance } from 'antd/es/message/interface';
import { message as antdMessage } from 'antd';

let messageInstance: MessageInstance | null = null;

export const setAntdInstances = (instances: { message?: MessageInstance }) => {
  if (instances.message) {
    messageInstance = instances.message;
  }
};

const safeCall = (fn?: (...args: any[]) => void) => {
  if (fn) fn();
};

export const message = {
  success: (content: any) => safeCall(() => (messageInstance ? messageInstance.success(content) : antdMessage.success(content))),

  error: (content: any) => safeCall(() => (messageInstance ? messageInstance.error(content) : antdMessage.error(content))),

  warning: (content: any) => safeCall(() => (messageInstance ? messageInstance.warning(content) : antdMessage.warning(content))),

  info: (content: any) => safeCall(() => (messageInstance ? messageInstance.info(content) : antdMessage.info(content))),
};
